import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
  bbArrayOfActiveSubscriptions, bbFindEntityWithinPortfolioOrSelf,
  bbFindUsersOnboardingProgress,
  isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import BRSubscriptionWidget from "../../../../../components/customBreachBits/info/BRSubscriptionWidget";
import BRBusinessAttacksAuthorizedControlWidget
  from "../../../../../components/customBreachBits/controllers/BRBusinessAttacksAuthorizedControlWidget";
import YourCIRTModulesWidgetPane from "./YourCIRTModulesWidgetPane";
import SettingsPageLoadingSkeleton from "./SettingsPageLoadingSkeleton";
import {Col, Row} from "reactstrap";
import CustomerInformationPane from "./CustomerInformationPane";
import PointOfContactWidget from "./PointOfContactWidget";
import Banner from "../../../../../assets/images/BreachRisk_Services_Settings_Banner.svg";
import BRSocialEngineeringAuthorizationWidget
  from "../../../../../components/customBreachBits/BRSocialReports/BRSocialEngineeringAuthorizationWidget";
import {Button} from "@material-ui/core";
import {HashLink as Link} from "react-router-hash-link";
import OnboardingProgressDisplay
  from "../../../../../components/customBreachBits/OnboardingProgress/OnboardingProgressDisplay";
import UserManagementTableForCustomers
  from "../../../../../components/customBreachBits/settings/UserManagementTableForCustomers";

const SettingsSubscriptionPage = (props) => {

  /*Get state*/
  const {customers, customerInView,} = useSelector(({customer}) => customer);
  const {entityInView, portfolios, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
  const authUser = useSelector(({auth}) => auth.authUser);
  const customer = customers ? customerInView ? customers[customerInView] : null : null;

  const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
  const isCustomer = isCurrentUserMemberOf(authUser, "customer");
  const isBRPortfolioCustomer = isCurrentUserMemberOf(authUser,"breachrisk_portfolio");
  const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");
  const isPartner = isCurrentUserMemberOf(authUser,"partner");

  const authUserCustomerArray = authUser && authUser.customers && Array.isArray(authUser.customers)
      ? authUser.customers
      : null;

  const userCustomerObjectInView = authUserCustomerArray
      && authUserCustomerArray.find((customer)=> customer.customer === customerInView)

  const authUserIsManager = userCustomerObjectInView && userCustomerObjectInView.manager;

  const entities = portfolios
  && portfolios[customerInView]
      ? portfolios[customerInView].entities
      : null;

  // const myEntity = entities
  // && entityInView
  //     ? entities[entityInView]
  //     : null;

  const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

  const subscriptionsArray = customer && customer.Subscriptions && Object.keys(customer.Subscriptions).length > 0 ? Object.values(customer.Subscriptions) : null
  // console.log("Subscriptions Array is ", subscriptionsArray);

  const includesCIRT = subscriptionsArray && customer["Stromboli"]

  const dispatch = useDispatch();

  const onboardingProgress = myEntity && myEntity.onboarding_progress;
  const ownershipVerified = onboardingProgress && onboardingProgress.verified_ownership ? onboardingProgress.verified_ownership : null;

  const arrayOfActiveSubscriptions = bbArrayOfActiveSubscriptions(customer);
  const hasActiveSubscription = arrayOfActiveSubscriptions ? arrayOfActiveSubscriptions.length > 0 : false;


  return (
      <div className="animated fadeIn animation-duration-7 ">
        {customer
             ? <>

              <Row>
                <Col lg={8}>
                  <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                </Col>
              </Row>

              <hr/>

              {  (isBRBusinessCustomer || isStaffAdmin)
                  && hasActiveSubscription
                  && <Row>
                    <Col sm={2} lg={2}> </Col>
                    <Col>
                      <OnboardingProgressDisplay/>
                    </Col>
                    <Col sm={2} lg={2}>
                    </Col>
                  </Row>
              }

              <h2>Account Information </h2>

                <Row>
                  <Col lg={12}>
                    <Row className={"text-center"}>
                      <Col className={"align-self-center"}>
                        <CustomerInformationPane ownershipVerified={ownershipVerified} customer={customer} myEntity={myEntity}/>
                      </Col>

                      <Col className={"align-self-center"}>
                        <PointOfContactWidget customer={customer}/>
                      </Col>

                    </Row>
                    <hr/>

                    {(isBRPortfolioCustomer || isBRBusinessCustomer || isPartner || isStaffAdmin ) &&
                        <>
                          <h2>BreachRisk™ Subscriptions </h2>
                          {(authUserIsManager || isStaffAdmin )&&
                              <Row className={"row text-center mb-2 pb-2"}>
                                <Col className={"col-12"}>
                                  <Button variant={"contained"}
                                          color="primary">
                                    <Link smooth to={`/board/settings/subscription`}
                                          style={{textDecoration: "none", color: "white"}}>
                                      Manage Subscriptions
                                    </Link></Button>
                                </Col>
                              </Row>
                          }
                          <BRSubscriptionWidget subscriptionObj={customer["Subscriptions"]} customer={customer}/>

                        </>
                    }
                    <hr/>
                    {(isStaffAdmin || isBRBusinessCustomer || isBRPortfolioCustomer) &&
                        <Row>
                          <Col>
                            <h4>Penetration Testing</h4>
                            <p>Enabling Penetration Testing allows BreachRisk to actively test possible threats. Feature can be enabled or disabled whenever you like. When you share your score, others will know if you have enabled.</p>
                            <BRBusinessAttacksAuthorizedControlWidget brSubscriptionRequired={"Pro"}/>
                          </Col>

                          <Col>
                            <h4>Social Engineering</h4>
                            <p>Enabling Social Engineering allows BreachRisk to actively spearphish identities we've found and you've provided. Feature can be enabled or disabled whenever you like. When you share your score, others will know if you have enabled.</p>
                            <BRSocialEngineeringAuthorizationWidget/>
                          </Col>

                        </Row>
                    }

                    <hr/>
                    {(authUserIsManager || isStaffAdmin) &&
                      <Row>
                      <Col>
                        <UserManagementTableForCustomers/>
                      </Col>
                    </Row>}
                  </Col>
                </Row>
              <Row>

                  <Col >


                    <hr/>
                    {(( isCustomer  && customer.Stromboli ) || ( isPartner || isStaffAdmin )) &&
                        <div>
                          <YourCIRTModulesWidgetPane customer={customer} isStaffAdmin/>
                          <hr/>
                        </div>
                    }
                  </Col>


                </Row>



            </>


            : <SettingsPageLoadingSkeleton/>
        }
      </div>
  )
};

export default SettingsSubscriptionPage;

